import { Inject, Injectable } from '@angular/core';
import { APP_SETTINGS, CoreModuleOptionsInterface } from '../core.module';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  private appConstants: any;
  private environment: any;

  constructor(
    @Inject(APP_SETTINGS) private settings: CoreModuleOptionsInterface
  ) {
    this.setAppConstants(this.settings.appConstants);
    this.environment = this.settings.environment;
  }

  getAppEnvironment() {
    return this.environment;
  }

  getAppConstants() {
    return this.appConstants;
  }

  private setAppConstants(value: any) {
    this.appConstants = value;
  }
}
